import React from 'react'
import { Collapse } from 'antd'
import { ProjectFormStepsType } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import CustomProjectFormPanelHeader from './CustomProjectFormPanelHeader/CustomProjectFormPanelHeader'
import {
  projectFormSectionHelpers,
  projectFormStateSelector,
  setProjectFormItemValue,
  projectFormCurrentStep,
} from 'src/features'
const { Panel } = Collapse

interface CustomProjectFormCollapseProps {
  panelKey: string
  headerTitle: string
  headerSubtitle: string
  children: React.ReactNode
}

const CustomProjectFormCollapse: React.FC<CustomProjectFormCollapseProps> = (props) => {
  const dispatch = useAppDispatch()
  const currentStep = useAppSelector(projectFormCurrentStep)
  const formValues = useAppSelector(projectFormStateSelector)

  const handlePanelChange = (value: ProjectFormStepsType[]) => {
    if (value.length > 1) {
      dispatch(setProjectFormItemValue({ key: 'activeStep', value: value[1] }))
    } else if (value.length === 0) {
      dispatch(setProjectFormItemValue({ key: 'activeStep', value: null }))
    } else if (value.length === 1) {
      dispatch(setProjectFormItemValue({ key: 'activeStep', value: value[0] }))
    } else {
      dispatch(setProjectFormItemValue({ key: 'activeStep', value: 'DEFINITION' }))
    }
  }

  const isStepCompleted = {
    DEFINITION: projectFormSectionHelpers.isDefinitionCompleted(formValues),
    LOCATION: projectFormSectionHelpers.isLocationCompleted(formValues),
    CONTENT: projectFormSectionHelpers.isContentCompelted(formValues),
    TAX_RELIEF: projectFormSectionHelpers.isTaxReliefCompleted(formValues),
    STOCK: projectFormSectionHelpers.isPriceCompleted(formValues),
    CERTIFICATION: projectFormSectionHelpers.isCertificationsCompleted(formValues),
    DOCUMENTATION: projectFormSectionHelpers.isDocumentationCompleted(formValues),
    CONFIGURATION: true, // this is always completed, is not required
  }[props.panelKey]


  return (
    <Collapse
      bordered={true}
      defaultActiveKey={[currentStep]}
      activeKey={currentStep}
      expandIconPosition={'end'}
      onChange={handlePanelChange}
    >
      <Panel
        key={props.panelKey}
        header={
          <CustomProjectFormPanelHeader
            title={props.headerTitle}
            subtitle={props.headerSubtitle}
            isActivePanel={(currentStep === props.panelKey) || isStepCompleted}
            isFullCompleted={isStepCompleted}
          />
        }
      >
        {props.children}
      </Panel>
    </Collapse>
  )
}

export default CustomProjectFormCollapse
